import { Entity } from 'src/app/core/utils/entity';

export abstract class UserPaginationParams extends Entity {
  constructor(
    public generalFilter: string,
    public page: number,
    public quantity: number,
    public userId?: string
  ) {
    super();
  }

  abstract getPath(): string;
}
